import { TopicGroup } from '../algebra1/lessons';
import { anglesAndLines } from './angles-lines';
import { triangles } from './triangles';
import { pythagorean } from './pythagorean';

export const geometryLessons: TopicGroup[] = [
  anglesAndLines,
  triangles,
  pythagorean
];